import { declareRoute } from "utilities/routes/route.utility";

export const apiDocsRoute = declareRoute("/apidocs");
